import React from 'react';
import Hero from '../components/Hero';
import DrivingSection from '../components/DrivingSection';
import WeatherSection from '../components/WeatherSection';
import SitePartner from '../components/SitePartner';
import ShareSection from '../components/ShareSection';

const QueensCounty = () => {
  return (
    <div className="min-h-screen bg-slate-50 pb-10">
      <Hero 
        title="Queens County" 
        subtitle="Central Prince Edward Island"
        imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773310180/queen_ebmdjm.jpg"
      />
      <div className="max-w-2xl mx-auto px-4 mt-6">
        <SitePartner />
        <div className="flex flex-col gap-8 mt-4">
          <WeatherSection 
            title="Charlottetown Weather" 
            delay={0.1} 
            headerClassName="bg-purple-600 text-white"
            link="https://weather.gc.ca/en/location/index.html?coords=46.243,-63.127"
            buttonText="Link To Charlottetown Weather"
            imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773272098/Charlottetown_egpkrs.png"
          />
          <DrivingSection 
            title="Queens County Driving Conditions" 
            delay={0.2} 
            headerClassName="bg-orange-500 text-white"
            imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773272098/Driving_c1vsow.png"
            link="https://511.gov.pe.ca/roadconditions?filters%5B0%5D%5Bs%5D=Queens+County"
            buttonText="Check Live Queen's County Driving conditions"
          />
        </div>
        <ShareSection />
      </div>
    </div>
  );
};

export default QueensCounty;